import { render, staticRenderFns } from "./CorrectAnswerToggler.vue?vue&type=template&id=596f9b44&scoped=true&"
import script from "./CorrectAnswerToggler.vue?vue&type=script&lang=js&"
export * from "./CorrectAnswerToggler.vue?vue&type=script&lang=js&"
import style0 from "./CorrectAnswerToggler.vue?vue&type=style&index=0&id=596f9b44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f9b44",
  null
  
)

export default component.exports